import "reflect-metadata";
import { inversifyContainer } from "infrastructure/ioc/ioc.container";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import { store } from "infrastructure/store/ConfigureStore";
import IMessagesService from "./IMessagesService";
import IRepository from "data/IRepository";
import { MessageStatus } from "features/messages/enums/messageStatus";
import { Dashboard_Messages, Messages_UpdateStatus } from "data/endpoints";
import { getRouteParams } from "features/shared/helpers/routeParams";
import { injectable } from "inversify";
import PagedDataResultUnreadDTO from "features/shared/dtos/PagedDataResultUnreadDTO";
import MessageSimplifiedDTO from "./dto/MessageSimplifiedDTO";
import { setMessages } from "infrastructure/store/messages/MessagesActions";
import { loadPortalConfig } from "features/shared/helpers/modules";

const portalConfig = loadPortalConfig();

@injectable()
export default class MessagesService implements IMessagesService {
  private readonly _updateStatusRespository: IRepository<void>;

  private readonly _messagesSimplifiedRepository: IRepository<
    PagedDataResultUnreadDTO<MessageSimplifiedDTO>
  >;

  constructor() {
    this._updateStatusRespository = inversifyContainer.get(IocTypes.Repository);
    this._messagesSimplifiedRepository = inversifyContainer.get(
      IocTypes.Repository
    );
  }

  async updateMessageStatus(
    status: MessageStatus,
    messageId: string
  ): Promise<void> {
    await this._updateStatusRespository.getOne({
      url: Messages_UpdateStatus,
      routeParams: getRouteParams("messageId", messageId),
      params: new URLSearchParams({ MessageStatus: status }),
    });
  }

  async loadAndStoreMessagesSimplified(customerId: string): Promise<void> {
    if (portalConfig.useMessages) {
      const fetchMessages = await this._messagesSimplifiedRepository.getOne({
        url: Dashboard_Messages,
        routeParams: new URLSearchParams({ customerId: customerId }),
        params: new URLSearchParams({ Page: "1", PageSize: "5" }),
      });
  
      this.storeMessagesSimplified(fetchMessages);   
    }
  }

  storeMessagesSimplified(
    messages: PagedDataResultUnreadDTO<MessageSimplifiedDTO>
  ): void {
    store.dispatch(setMessages(messages));
  }
}
